module.exports = __webpack_public_path__ + "media/images/french_flag-b6cdca65d4ef95cb8881be90cb847710.jpg";